import { Button } from '@jouzen/ecom-components/v3/Button';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useScroll, useTransform } from 'framer-motion';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useRef } from 'react';

import { EventType } from '@/analytics/types';
import Motion from '@/app/components/Motion';
import { STORE_POP_PATHNAME } from '@/app/consts/pathnames';

import FeatureHighlights, {
  type FeatureHighlightsType,
} from './FeatureHightlights';

const FEATURE_HIGHLIGHTS: FeatureHighlightsType[] = [
  {
    id: 0,
    title: 'fitness_features_sleep_lab_title',
    description: 'oura_features_activity_description',
    image: 'fitness/fn-activity-detection-device',
  },
  {
    id: 1,
    title: 'oura_features_sickness_title',
    description: 'oura_features_sickness_description',
    image: 'fitness/fn-sickness-device',
    reverse: true,
  },
  {
    id: 2,
    title: 'oura_features_heart_rate_title',
    description: 'fitness_features_heart_rate_description',
    image: 'fitness/fn-heart-rate-device',
  },
  {
    id: 3,
    title: 'oura_features_readiness_title',
    description: 'oura_features_readiness_description',
    image: 'fitness/fn-readiness-detection-device',
    reverse: true,
  },
];

const FitnessFeatures = () => {
  const path = usePathname();
  const t = useTranslations();
  const target = useRef<HTMLDivElement>(null);

  const { scrollYProgress } = useScroll({ target });
  const backgroundColor = useTransform(
    scrollYProgress,
    [0, 0.5],
    ['#C1DDEC', '#DBD7E9'],
  );

  const handleClick = () => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'shop_now',
      action: 'go_to_pdp',
      location: 'features_module',
      module: 'features_module',
      path,
    });
  };

  return (
    <Motion style={{ backgroundColor }}>
      <section className="pt-20 pb-24 md:pt-16 md:pb-20" ref={target}>
        <LayoutGrid rowGap={32}>
          <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
            <Typography
              Element="h3"
              variant="unset"
              color="inherit"
              height="snug"
              weight="light"
              align="centerLgLeft"
              className="text-heading-xl lg:text-6xl"
            >
              {t('oura_features_title')}
            </Typography>
          </GridItem>
          <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main', md: 13 }}>
            <Typography
              variant="unset"
              color="inherit"
              height="snug"
              weight="light"
              className="text-[1.375rem] lg:text-3xl"
            >
              {t('oura_features_subtitle')}
            </Typography>
          </GridItem>
        </LayoutGrid>
        <div className="mt-20">
          <FeatureHighlights features={FEATURE_HIGHLIGHTS} />
          <LayoutGrid>
            <GridItem
              colEnd={{ sm: 'main' }}
              colStart={{ sm: 'main' }}
              className="md:text-center"
            >
              <Button
                onClick={handleClick}
                href={STORE_POP_PATHNAME}
                className="mt-6 md:mt-12"
              >
                {t('header_shop_now')}
              </Button>
            </GridItem>
          </LayoutGrid>
        </div>
      </section>
    </Motion>
  );
};

export default FitnessFeatures;
